"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.replace-all.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _CustomerTable = require("../CustomerTable.vue");
var customer = _interopRequireWildcard(require("@/api/customer"));
var _CustomerInfoForm = _interopRequireDefault(require("./CustomerInfoForm.vue"));
var _OrderCustomerHistory = _interopRequireDefault(require("./OrderCustomerHistory.vue"));
var _TrackingBirthdayDiscount = _interopRequireDefault(require("./TrackingBirthdayDiscount.vue"));
var _lodash = require("lodash");
var _customerGroup = require("@/api/customer-group");
var _customerSource = require("@/api/customer-source");
var CustomerDialog = /*#__PURE__*/function (_Vue) {
  function CustomerDialog() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, CustomerDialog, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "GenderType", _CustomerTable.GenderType);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "tabName", "info");
    (0, _defineProperty2.default)(_this, "loadingButton", false);
    (0, _defineProperty2.default)(_this, "rules", {
      name: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      phone: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      customerGroupId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      customerSourceId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      }
      // staffId: {
      //   required: true,
      //   message: "Field is required",
      //   trigger: "submit",
      // },
      // skinStatusId: {
      //   required: true,
      //   message: "Field is required",
      //   trigger: "submit",
      // },
    });
    (0, _defineProperty2.default)(_this, "customerRankId", 0);
    return _this;
  }
  (0, _inherits2.default)(CustomerDialog, _Vue);
  return (0, _createClass2.default)(CustomerDialog, [{
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$confirm("Confirm delete this customer?", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 3:
              this.loadingButton = true;
              _context.next = 6;
              return customer.customerApi.delete(this.form.id);
            case 6:
              this.$notify.success({
                title: "Delete customer",
                message: "Successfully"
              });
              this.visible = false;
              this.$emit("submit:success");
            case 9:
              _context.prev = 9;
              this.loadingButton = false;
              return _context.finish(9);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this2 = this;
        var valid, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$refs.customerInfoForm.$refs.form.validate();
            case 2:
              valid = _context2.sent;
              data = {
                customer: this.form,
                staffId: this.form.staffId,
                skinStatusId: this.form.skinStatusId,
                addressCityId: this.form.addressCityId,
                addressDistrictId: this.form.addressDistrictId,
                addressWardId: this.form.addressWardId,
                skinStatusIds: this.form.skinStatusIds,
                customerGroupId: this.form.customerGroupId,
                customerSourceId: this.form.customerSourceId,
                customerRankId: this.form.customerRankId
              };
              this.loadingButton = true;
              customer.create(data).then(function (res) {
                if (res.status) {
                  _this2.$notify.success({
                    title: "Create customer",
                    message: "Successfully"
                  });
                  _this2.visible = false;
                  _this2.$emit("submit:success");
                }
              }).finally(function () {
                _this2.loadingButton = false;
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateRank",
    value: function () {
      var _updateRank = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              data = {
                customerRankId: this.form.customerRankId
              };
              if (!(0, _lodash.isEqual)(this.customerRankId, this.form.customerRankId)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              _context3.next = 5;
              return customer.updateRank(this.form.id, data);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function updateRank() {
        return _updateRank.apply(this, arguments);
      }
      return updateRank;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var _this3 = this;
        var valid, form, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.$refs.customerInfoForm.$refs.form.validate();
            case 2:
              valid = _context4.sent;
              form = (0, _objectSpread2.default)({}, this.form);
              delete form.customerRank;
              data = {
                customer: form,
                staffId: this.form.staffId || 0,
                addressCityId: this.form.addressCityId,
                addressDistrictId: this.form.addressDistrictId,
                addressWardId: this.form.addressWardId,
                skinStatusIds: this.form.skinStatusIds,
                customerGroupId: this.form.customerGroupId,
                customerSourceId: this.form.customerSourceId
              };
              this.loadingButton = true;
              _context4.next = 9;
              return this.updateRank();
            case 9:
              customer.update(this.form.id, data).then(function (res) {
                if (res.status) {
                  _this3.$notify.success({
                    title: "Update customer",
                    message: "Successfully"
                  });
                  _this3.visible = false;
                  _this3.$emit("submit:success");
                }
              }).finally(function () {
                _this3.loadingButton = false;
              });
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      var _this4 = this;
      this.visible = true;
      this.status = "create";
      this.form = {
        gender: _CustomerTable.GenderType.Female,
        addressCityId: null,
        addressDistrictId: null,
        addressWardId: null
      };
      this.$nextTick(function () {
        _this4.$refs.customerInfoForm.$refs["form"].clearValidate();
      });
    }
  }, {
    key: "handleCreateFromShopifyOrder",
    value: function () {
      var _handleCreateFromShopifyOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(data) {
        var _customerSources$find,
          _customerGroups$find,
          _this5 = this;
        var customerSources, customerGroups;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.visible = true;
              this.status = "create";
              _context5.next = 4;
              return _customerSource.customerSourceApi.findAll({
                limit: 50,
                page: 1
              });
            case 4:
              customerSources = _context5.sent.data.customerSources;
              _context5.next = 7;
              return _customerGroup.customerGroupApi.findAll({
                limit: 50,
                page: 1
              });
            case 7:
              customerGroups = _context5.sent.data.customerGroups;
              console.log({
                data: data
              });
              this.form = {
                name: data.name,
                phone: data.phone == "No phone number" ? "" : data.phone,
                email: data.email,
                receiverAddress: data.address.replaceAll("\n", " "),
                customerSourceId: (_customerSources$find = customerSources.find(function (item) {
                  return item.name == "Website";
                })) === null || _customerSources$find === void 0 ? void 0 : _customerSources$find.id,
                customerGroupId: (_customerGroups$find = customerGroups.find(function (item) {
                  return item.name == "Retail";
                })) === null || _customerGroups$find === void 0 ? void 0 : _customerGroups$find.id
              };
              this.$nextTick(function () {
                _this5.$refs.customerInfoForm.$refs["form"].clearValidate();
              });
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleCreateFromShopifyOrder(_x) {
        return _handleCreateFromShopifyOrder.apply(this, arguments);
      }
      return handleCreateFromShopifyOrder;
    }()
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      var _this6 = this;
      this.form = (0, _objectSpread2.default)({}, data);
      this.getDetail();
      this.status = "update";
      this.visible = true;
      this.tabName = "info";
      this.$nextTick(function () {
        _this6.$refs.customerInfoForm.$refs["form"].clearValidate();
      });
    }
  }, {
    key: "getDetail",
    value: function () {
      var _getDetail = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        var res, detail;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return customer.customerApi.findOne(this.form.id);
            case 2:
              res = _context6.sent;
              detail = res.data.customer;
              this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, detail), {}, {
                staffId: detail.staff && detail.staff.id,
                addressCityId: detail.addressCity && detail.addressCity.id,
                addressDistrictId: detail.addressDistrict && detail.addressDistrict.id,
                addressWardId: detail.addressWard && detail.addressWard.id,
                skinStatusIds: detail.skinStatuses && detail.skinStatuses.map(function (e) {
                  return e.id;
                }),
                customerGroupId: detail.customerGroup && detail.customerGroup.id,
                customerSourceId: detail.customerSource && detail.customerSource.id,
                customerRankId: detail.customerRank && detail.customerRank.id,
                totalSale: res.data.totalSale,
                nextRank: res.data.nextRank,
                currentRank: res.data.currentRank
              });
              this.customerRankId = detail.customerRank && detail.customerRank.id;
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getDetail() {
        return _getDetail.apply(this, arguments);
      }
      return getDetail;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
CustomerDialog = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    CustomerInfoForm: _CustomerInfoForm.default,
    OrderCustomerHistory: _OrderCustomerHistory.default,
    TrackingBirthdayDiscount: _TrackingBirthdayDiscount.default
  }
})], CustomerDialog);
var _default = exports.default = CustomerDialog;